import { useDispatch } from 'react-redux'
import type { AppDispatch } from '../store'

/**
 * `useDispatch()` with the store's own dispatch type, so thunks created with
 * `createAsyncThunk` (and their `.unwrap()`) type-check at the call site.
 * The untyped `useDispatch()` returns `Dispatch<UnknownAction>`, which rejects
 * thunk actions.
 */
export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
